import { render, staticRenderFns } from "./turn-view.vue?vue&type=template&id=06967137&"
import script from "./turn-view.vue?vue&type=script&lang=js&"
export * from "./turn-view.vue?vue&type=script&lang=js&"
import style0 from "./turn-view.vue?vue&type=style&index=0&id=06967137&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports